/* Reviews marquee: fill each row until it is wider than the screen, then duplicate for a
   seamless -50% loop. Lives here rather than in the section's {% javascript %} block —
   Shopify's section-JS bundler silently omitted it from compiled_assets/scripts.js, so the
   rows animated with only one copy and left a blank gap. */
(function () {
    function fill(track) {
      var row = track.parentElement;
      if (!row) return;

      // Restore the single rendered copy before measuring, so resizing recomputes cleanly
      if (track.dataset.baseHtml) {
        track.classList.remove('is-ready');
        track.innerHTML = track.dataset.baseHtml;
      } else {
        track.dataset.baseHtml = track.innerHTML;
      }

      var base = [].slice.call(track.children);
      if (!base.length) return;

      var setWidth = track.scrollWidth;
      var rowWidth = row.offsetWidth;
      if (!setWidth || !rowWidth) return;

      // Enough copies to cover the screen, plus one so nothing is ever bare mid-slide
      var sets = Math.ceil(rowWidth / setWidth) + 1;
      for (var i = 1; i < sets; i++) {
        base.forEach(function (node) { track.appendChild(node.cloneNode(true)); });
      }
      // Duplicate the filled track once — that's what makes translateX(-50%) seamless
      [].slice.call(track.children).forEach(function (node) {
        track.appendChild(node.cloneNode(true));
      });

      // Travel distance scales with the number of copies, so scale the duration to match
      // and keep the perceived speed identical on every screen size.
      var section = track.closest('[data-reviews]');
      var base_s = 55;
      if (section) {
        var v = parseFloat(getComputedStyle(section).getPropertyValue('--marq-speed'));
        if (!isNaN(v) && v > 0) base_s = v;
      }
      track.style.setProperty('--marq-dur', (base_s * sets) + 's');
      track.classList.add('is-ready');
    }

    function init() {
      var tracks = [].slice.call(document.querySelectorAll('[data-marquee]'));
      if (!tracks.length) return;
      tracks.forEach(fill);

      var lastWidth = window.innerWidth;
      var timer;
      window.addEventListener('resize', function () {
        if (window.innerWidth === lastWidth) return;   // ignore mobile URL-bar height changes
        lastWidth = window.innerWidth;
        clearTimeout(timer);
        timer = setTimeout(function () { tracks.forEach(fill); }, 200);
      });
    }

    if (document.readyState !== 'loading') { init(); }
    else { document.addEventListener('DOMContentLoaded', init); }
    // Re-fill when the section is re-rendered in the theme editor
    document.addEventListener('shopify:section:load', init);
  })();
